
  import Vue from "vue";
  import { Component } from "vue-property-decorator";
  
  @Component
  export default class TitleH2 extends Vue {}
